// eslint-disable-next-line local-rules/disallow-lodash/isEqual
import lodashIsEqual from 'lodash/isEqual'
import { Entries } from 'type-fest'
/**
 * Get entries of an object with types
 * Only use this function if you are in full control of the object's keys and values.
 */
export const getEntries = <T extends object>(obj: T) => Object.entries(obj) as Entries<T>

/**
 * Performs a deep comparison between two values to determine if they are equivalent.
 * Wraps around _.isEqual in a more typesafe manner.
 */
export function isEqual<T>(a: T, b: T): boolean {
    return lodashIsEqual(a, b)
}

/**
 * Creates an object composed of the picked object properties.
 *
 * @example
 * const object = { 'a': 1, 'b': '2', 'c': 3 }
 * pick(object, ['a', 'c']) // => { 'a': 1, 'c': 3 }
 */
export function pick<T extends object, K extends keyof T>(obj: T, keys: K[]): Pick<T, K> {
    const result = {} as Pick<T, K>
    keys.forEach(key => {
        result[key] = obj[key]
    })
    return result
}
